import { render, staticRenderFns } from "./manage-document-approval-popup.vue?vue&type=template&id=5c6aa23e&"
import script from "./manage-document-approval-popup.vue?vue&type=script&lang=js&"
export * from "./manage-document-approval-popup.vue?vue&type=script&lang=js&"
import style0 from "./manage-document-approval-popup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports